import { Flex } from 'components';
import styled from 'styled-components';

const ColorBlock = styled(Flex)<{ $background: string }>`
  min-width: 36px;
  height: 36px;
  padding: 0 6px;
  border-radius: 8px;
  background: ${({ $background }) => $background};
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  border: 1px solid ${({ theme }) => theme.palette.neutral.lightGrey};
  flex-shrink: 0;
`;

const SubTypeMarker = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.neutral.greyButton};
  font-size: 14px;
  line-height: 1;
`;

const Name = styled.span<{ $isSubType?: boolean }>`
  ${({ $isSubType, theme }) =>
    $isSubType &&
    `
    color: ${theme.palette.text.secondary};
    font-size: ${theme.textStyles.body2.fontSize}px;
  `}
`;

interface Props {
  color_code?: string;
  color_icon?: string;
  name?: string;
  isSubType?: boolean;
}

export const TaskTypeBadge: React.FC<Props> = ({
  color_code,
  color_icon,
  name,
  isSubType
}) => (
  <Flex alignItems="center" gap="8px" minWidth={0}>
    {isSubType && <SubTypeMarker>└</SubTypeMarker>}
    <ColorBlock $background={color_code || '#cccccc'}>
      {(color_icon || '?').slice(0, 3)}
    </ColorBlock>
    <Name $isSubType={isSubType}>{name || '—'}</Name>
  </Flex>
);
